<template>
    

    <form v-on:submit.prevent="createProject()" class="modal-cardx" >
        
        <section class="modal-card-body" style="height: auto">
            <div class="container">
            <router-link :to="{ name: 'Dashboard' }" class="is-pulled-right">
                <b-icon icon="close"></b-icon>
            </router-link>
            
            <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false" v-if="setupStep != 2">
            </b-loading>
            
            <b-steps	
            v-if="setupStep < 4"
            label-position="bottom"
            :animateInitially="false"
            v-model="setupStep"
            :has-navigation="false">
            
                <b-step-item step="1" :label="'Task' + (modelType && setupStep > 0? ': '+modelType : '')">
                    <!-- <h1 class="title has-text-centered">Select a model output</h1> -->
                    <p class="subtitle is-7 has-text-centered is-uppercase">SELECT A TASK</p>
                    <h2 class="subtitle is-4 has-text-centered">
                        Select a task to customize
                    </h2>
                    <div class="columns is-vcentered">
                        <div class="column is-8 is-offset-2 is-mobile">

                    <div class="tile is-ancestor">
                        <div class="tile is-parent" v-for="i in modelTypeList.slice(0,3)">
                            <a @click="taskSelection(i.id)">
                                <span v-if="!availableTasks.includes(i.id)" style="margin-top: -0.7em; padding-top: 0em;" class="is-pulled-right">
                                    <b-tag type="is-dark">
                                        <i class="fa fa-link"></i>
                                        Join early access
                                    </b-tag>
                                </span>
                                <article class="tile is-child box">
                                    <!-- <b-tag>Quick & Prototype</b-tag>
                                    <b-tag>No training data</b-tag> -->
                                <p class="title is-5 has-text-centered has-text-grey is-uppercase mb-0">{{i.name}}</p>
                                <b-image :class="'subtitle is-centered cardx  '" :src="require(`@/images/ai-task-${i.id}.svg`)" 
                                        style="margin-top: 0em; margin-bottom: -1em; max-height: 15em; min-width: 12em;">
                                </b-image>
                                </article>
                                
                                
                                <br>
                                <p class="subtitle is-6 mt-1 mb-0" v-for="tag in i.tags">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                                    {{ tag }}
                                </p>
                            </a>
                        </div>
                    </div>
                    </div></div>
                    
                </b-step-item>

                <b-step-item step="2" :label="'Customization' + (learningStrategy && setupStep > 1? ': '+ learningStrategyMapping[learningStrategy] : '')">
                    <p class="subtitle is-7 has-text-centered is-uppercase">Customization</p>
                    <h2 class="subtitle is-4 has-text-centered">
                        Customization strategy for text {{ modelType }}
                    </h2>
                    <div class="columns is-centered">
                        <div class="column is-6 is-desktop">

                    <div class="tile is-ancestor">
                        <div class="tile is-parent">
                            
                            <a @click="learningStrategy = 'llm-prompt'; setupStep += 1; createProjectDraft()">
                                
                            <article class="tile is-child box">
                                <b-tag type="is-warningx">
                                <i class="fa fa-help"></i>
                                Experimental
                                </b-tag>
                            <p class="title is-4 has-text-centered has-text-grey is-uppercase mb-6 mt-5 pt-5 pb-6">Few-Shot Model</p>
                            <p class="subtitle is-6 has-text-centered">
                                Ideal for quick deployment with limited or no data
                            </p>
                            
                            </article>
                            <p class="subtitle is-6 mt-5 mb-0">
                                <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"> <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                                Quick & prototype mode
                            </p>

                            <p class="subtitle is-6 mt-0 mb-0">
                                <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"> <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                                No training data required
                            </p>
                            <p class="subtitle is-6 mt-0 mb-0">
                                <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"> <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                                Convert to fine-tune model later
                            </p>
                            </a>
                        </div>
                        <div class="tile is-parent">
                            <a @click="learningStrategy = 'fine-tune'; setupStep += 1; createProjectDraft()">
                            <article class="tile is-child box">
                            <p class="title is-4 has-text-centered has-text-grey is-uppercase mb-6 mt-5 pt-6 pb-6">Fine-Tune Model</p>
                            <p class="subtitle is-6 has-text-centered">
                                Ideal for optimal results with moderate data
                            </p>
                            
                            </article>
                            <p class="subtitle is-6 mt-5 mb-0">
                                <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"> <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                                High-performance mode
                            </p>
                            <p class="subtitle is-6 mt-0 mb-0">
                                <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"> <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                                Training data required
                            </p>
                            
                            <p class="subtitle is-6 mt-0 mb-0">
                                <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"> <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                                More powerful and precise
                            </p>
                            </a>
                        </div>
                        <!-- <div class="tile is-parent">
                            <article class="tile is-child box">
                            <p class="title">Third column</p>
                            <p class="subtitle">With some content</p>
                            <div class="content">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ornare magna eros, eu pellentesque tortor vestibulum ut. Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.</p>
                            </div>
                            </article>
                        </div> -->
                    </div>
                    </div></div>
                    
                </b-step-item>

                <b-step-item step="3" label="Setup" v-if="learningStrategy == 'llm-prompt'">
                    <div class="columns is-centered">
                        <div class="column is-12">
                    <p class="subtitle is-7 has-text-centered is-uppercase">SETUP</p>
                    <h2 class="subtitle is-4 has-text-centered">
                        Setup your few-shot model
                    </h2>
                    <Try :modelType="modelType" :project="newProject" @updatePromptModel="updatePromptModel"/>
                    <div class="columns is-centered">
                        
                        <div class="column is-9 is-mobile">
                            <div class="columns">
                                <div class="column is-full">
                                

                                <div class="" v-if="false">
                                    <div class="columns">
                                        <div class="column is-12">
                                            <div class="is-pulled-left">
                                                <b-button type="is-white" v-if="try_records.length > 0">
                                                    <b>Records:</b> {{  try_records.length }}
                                                </b-button>
                                            </div>
                                            <br><br>
                                            <div class="content pb-50" v-for="row in try_records">
                                                <Records :row="row" :train="true" :project="newProject" :currentUser="currentUser"></Records>
                                            </div>
                                            <br><br><br><br><br>
                                        </div>
                                    </div>
                                </div>
                                </div>
                        </div>
                        </div>
                        
                    </div>

                    </div></div>
                    
                </b-step-item>
                
                
                
               

                <b-step-item step="3" label="Setup" v-else>
                    <p class="subtitle is-7 has-text-centered is-uppercase">SETUP</p>
                    <h2 class="subtitle is-4 has-text-centered">
                        Setup your fine-tune model with training data
                    </h2>
                    
                    <div class="columns is-centered">
                        <div class="column is-8">
                            <b-field class="control is-pulled-right" grouped>

                    <b-field position="is-right" >
                            <p class="control">
                                    <b-button
                                        @click="isModalUploadOpen = true; getRows()"
                                        type="is-primary">
                                        <i class="fa fa-plus"></i>
                                        Dataset
                                    </b-button>
                            </p>
                    </b-field>
                    <b-field position="is-right">
                            <p class="control">
                                    <b-button
                                        @click="isModalLabelsOpen = true; getRows()"
                                        type="is-primary">
                                        <i class="fa fa-tags"></i>
                                        {{ modelType == "classification" ? "Labels" : "Tags" }}
                                    </b-button>
                                    &nbsp;
                                   
                        </p>
                    </b-field>
                    <b-field position="is-right" v-if="rows.length > getProjectRowsLimit()">
                            <p class="control">
                                <b-button tag="router-link" :to="'/d/pricing'">
                                    Upgrade
                                </b-button>
                                </p>
                            </b-field>
                       
                    
                </b-field>

                <b-field position="is-left">
                            <p class="controlx">
                                <!-- <b-button @click="getRows" type="is-white">
                                    <b>Records added:</b> {{  rows.length }} / {{  getCreditsOrRecordsLimit() }}
                                </b-button> -->
                            </p>
                        </b-field>
                
                    </div>
                </div>
                    <div class="columns">
                        <div class="column is-8 is-offset-2">
                            <div class="columns">
                            <div class="column is-full">
                                <div class="columns is-6" v-if="rows.length < 1">

                            </div>
                                    <b-table
                                    v-if="rows"
                                    :data="rows"
                                    :per-page="10"
                                    :total="rows.length"
                                    :pagination-position="'both'"
                                    paginated
                                    pagination-size="is-small"
                                    :loading="isLoading"
                                    >
                                    <h4 class="columns is-6 has-text-grey" v-if="rows.length < 1">
                                    💡 Tip: Get better results by adding a minimum of 50 records
                                    </h4>
                                    <b-tooltip type="is-dark" position="is-top" multilined>
                                        <i class="fa fa-info-circle"></i>

                                        <template #content>
                                            <span>
                                                Your upload file must have at maximum {{ getProjectRowsLimit() }} records
                                            </span>
                                        </template>
                                        </b-tooltip>
                                    <template #top-left>
                                            <b>Records</b>: {{ rows.length }} / {{ getProjectRowsLimit() }} &nbsp; <b-button
                        @click="getRows"
                        type="is-white" size="is-small">
                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"/></svg>
                        
                    </b-button>
                                    </template>
                                    
                                    
                                    <b-table-column width="100" field="text" label="" v-slot="props" v-if="modelType == 'extraction'">
                                            <RecordsExtract @close="props.close" :train="true" :row="props.row" :project="newProject" :currentOrg="currentUser" :currentUser="currentUser"></RecordsExtract>
                                    </b-table-column>
                                    <b-table-column width="100" field="text" label="" v-slot="props" v-else>
                                            <RecordsClassify @close="props.close" :train="true" :row="props.row" :project="newProject" :currentOrg="currentUser" :currentUser="currentUser"></RecordsClassify>
                                    </b-table-column>
                                </b-table>
                                        <!-- <div class="content pb-100" v-for="row in rows">
                                            <RecordsExtract :row="row" :train="true" :project="project" :currentUser="currentUser"></RecordsExtract>
                                        </div> -->
                                        <br><br><br>
                                        
                                </div>
                            </div>
                        </div>
                    </div>
                </b-step-item> 

                <b-step-item step="4" label="Review">
                        
                    <p class="subtitle is-7 has-text-centered is-uppercase">REVIEW</p>
                    <h2 class="subtitle is-4 has-text-centered">
                        Review and start training your model
                    </h2>
                    
                        <div class="columns">
                        <div class="column is-8 is-offset-2">
                            <div class="columns">
                                <div class="column is-6">

                                    <b-field label="Name" :type="!projectName?'is-danger':''">
                                        <b-input
                                            type="text"
                                            size="is-medium"
                                            v-model="projectName"
                                            placeholder="Project name"
                                            required>
                                        </b-input>
                                    </b-field>
<!-- 
                        <b-field label="Description">
                            <b-input
                                type="text"
                                size="is-medium"
                                v-model="projectDescription"
                                placeholder="Short description"
                                required>
                            </b-input>
                        </b-field> -->

                        <b-field label="Task">
                            <b-input
                                disabled
                                type="text"
                                size="is-medium"
                                v-model="modelType"
                                required>
                            </b-input>
                        </b-field>
                        <b-field label="Customization">
                            <b-input
                                disabled
                                type="text"
                                size="is-medium"
                                :value="learningStrategyMapping[learningStrategy]"
                                required>
                            </b-input>
                        </b-field>

                        <b-field :label="modelType == 'classification' ? 'Classify labels' : 'Extract tags'" :type="!labels || labels.length < 1?'is-danger':''">
                            <b-taginput
                                size="is-medium"
                                type="is-info"
                                expanded
                                :autocomplete="true"
                                v-model="labels"
                                :allow-new="true"
                                :open-on-focus="true"
                                :placeholder="'➕ Add '+ (modelType == 'classification' ? 'a label' : 'a tag')">
                            </b-taginput>
                        </b-field>
                        <br><br><br>
                        
                                    </div>
                        
                                <div class="column is-6">
                                    <b-button v-if="!hasEnoughCredits()" class="is-pulled-right" type="is-primary" size="is-small" tag="router-link" :to="'/d/pricing'" target="_blank">
                                    <i class="fa fa-plus"></i> Add credits
                                </b-button>
                                    <b-field label="Training cost estimation" message="Preview of how much your training will cost">
                                
            
            <p class="is-size-5">
                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"/></svg>
                {{ creditsNeeded() }} credits
                <small v-if="!hasEnoughCredits()">({{ availableCredits() }} credits available)</small>
            </p>
            
        </b-field>
        <b-field label="Dataset" class="controlx">
                            <div class="buttonsx">
                                <b-button
                                
                                size="is-medium" expanded
                                @click="isModalUploadOpen = true"
                                type="is-whitex">
                                
                                <!-- <i class="fa fa-plus"></i>  -->
                                {{  rows.length }} records added
                            </b-button>
                            <!-- <b-button @click="isModalRecordsOpen = true" >
                                {{  rows.length }} records added
                            </b-button> -->
                            
                            </div>
                        </b-field>
                        <!-- <b-field label="Parameters">
                        <b-collapse 
                        :open="false" 
                        position="is-top" 
                        aria-id="contentIdForA11y4">
                        <template #trigger="props">
                            <a
                                aria-controls="contentIdForA11y4"
                                :aria-expanded="props.open">
                                {{ !props.open ? 'Set advanced parameters' : 'Hide advanced parameters' }}
                            </a>
                        </template>
                        <CodeEditor value="1" :line-nums="true" :display-language="false" theme="vs" :copy-code="false" @textarea="setTextarea" width="100%" height="380px"></CodeEditor>

                    </b-collapse>
</b-field> -->
                        
                        <b-field label="Language">
                            <b-select v-model="language" size="is-medium" name="language" required expanded  placeholder="Choose a language">
                                <option value='Multilingual' selected>Multilingual</option>
                                <option v-for="l in ['English', 'Mandarin / Chinese', 'Hindi', 'Spanish', 'Portuguese', 'French', 'Arabic', 'Other - Multilingual']" :value="l">{{ l }}</option>
                            </b-select>
                        </b-field>
                        
                        <b-field label="Foundation Model" message="Select the size of the model's capacity. Model capacity refers to the model's ability to learn complex patterns in data. Usually, Small size is better for fast inference cases and Large for better accuracy.">
                            <b-select v-model="modelSize" size="is-medium" placeholder="Select a model size" expanded>
                            
                                <option value="small">Small</option>
                                <option value="medium">
                                    Medium
                                </option>
                                <option value="large" :disabled="!isProPlan()">
                                    Large
                                    <b-tag v-if="!isProPlan()" type="is-dark">(Available on PRO plan)</b-tag>
                                </option>
                                <option value="mistral" disabled>Mistral 7B (Coming soon)</option>
                                <option value="mistral" disabled>LLama 2 70B (Coming soon)</option>
                            </b-select>
                            
                        </b-field>
                        <b-field  :label="!isProPlan() ? 'Trials (Available on PRO plan)': 'Trials'" message="Choose the quantity of models for training. Trials indicate the training speed, with 1 trial being quick training (less than 10 minutes) and 10 trials signifying extended training (over 1 hour).">
            <b-slider :disabled="!isProPlan()" v-model="modelTrials" :step="1" :min="1" :max="10" size="is-medium" name="speed" required expanded>
                <template slot="tooltip" slot-scope="props">
                    {{ props.value }}
                </template>
            </b-slider>
        </b-field>
                        <br><br><br>
                       
                        
                        
                    </div></div></div></div>
                    
                </b-step-item>

                
                <template
                #navigation="{previous, next}">
                    <div class="footer">
                        
                    <b-field>
                        <b-button
                            v-if="!previous.disabled"
                            expanded
                            type="is-light"
                            size="is-medium"
                            icon-pack="fas"
                            icon-left="angle-left"
                            :disabled="previous.disabled"
                            @click.prevent="previous.action">
                            Previous
                        </b-button>
                        <b-button
                            v-if="previous.disabled"
                            expanded
                            tag="router-link"
                            size="is-medium"
                            icon-pack="fas"
                            icon-left="angle-left"
                            :to="`/dashboard`">
                            Back to dashboard
                        </b-button>
                        <b-button
                            v-if="setupStep == 0"
                            expanded
                            size="is-medium"
                            icon-pack="fas"
                            icon-right="angle-right"
                            :disabled="next.disabled"
                            @click="createProjectDraft"
                            @click.prevent="next.action">
                            Customize
                        </b-button>
                        <b-button
                            v-else-if="setupStep == 1"
                            expanded
                            type="is-info"
                            size="is-medium"
                            icon-pack="fas"
                            icon-right="angle-right"
                            :disabled="next.disabled"
                            @click="createProjectDraft"
                            @click.prevent="next.action">
                            Setup
                        </b-button>
                        <b-button
                            v-else-if="setupStep == 2"
                            expanded
                            size="is-medium"
                            icon-pack="fas"
                            icon-right="angle-right"
                            :disabled="next.disabled"
                            @click="getLabels"
                            @click.prevent="next.action">
                            Done
                        </b-button>
                        <b-button
                            v-else-if="setupStep == 3 && availableTasks.includes(modelType)"
                            tag="button"
                            @click="createProject"
                            size="is-medium"
                            type="is-info"
                            expanded 
                            :disabled="!availableTasks.includes(modelType) || !projectName || !hasEnoughCredits()">
                            Train
                        </b-button>
                        <b-button
                            v-else
                            expanded
                            size="is-medium"
                            icon-pack="fas"
                            icon-right="angle-right"
                            :disabled="next.disabled"
                            @click.prevent="next.action">
                            Review
                        </b-button>
                    </b-field>
                    
                    </div>
                </template>
                
            </b-steps>

            <div v-else>
                        
                        <span v-if="isLoading">
                            <p class="subtitle is-7 has-text-centered is-uppercase">TRAIN</p>
                            <h2 class="subtitle is-4 has-text-centered">
                                Creating your project AI...
                            </h2>
                        </span>
                        <span v-else>
                            <p class="subtitle is-7 has-text-centered is-uppercase">TRAIN</p>
                            <h2 class="subtitle is-4 has-text-centered">
                                Your model is training...
                            </h2>
                        </span>
                        <br>
                        
                        
                        <div class="columnsx">
                        <div class="columnx is-half is-offset-one-quarter">
                            <div class="columns is-centered">
                        
                                <div class="column is-6 is-centered">
                                    <h4 class="title is-4">
                                        🎉🎉 Congratulations!
                                    </h4>
                                    <p class="subtitle is-6">
                                        This is a quick overview of what is the next steps to take.
                                    </p>
                                    <br>
                                    <h4 class="title is-5">
                                        ✅ You have done the model customization!
                                    </h4>
                                    <h4 class="title is-5">
                                        ⏭️ Next steps
                                    </h4>
                                    <h4 class="title is-6">
                                        &nbsp;&nbsp;&nbsp;3. Your model is training and will be automatically deployed
                                    </h4>
                                    <h4 class="title is-6">
                                        &nbsp;&nbsp;&nbsp;4. Connect your model via <span class="has-text-weight-bold">API endpoint</span> or try on <span class="has-text-weight-bold">Predict preview</span>
                                    </h4>
                                    <h4 class="title is-6">
                                        &nbsp;&nbsp;&nbsp;5. Continuously evaluate your model predictions and improve it using Metatext tools
                                    </h4>
                                </div>
                                <div class="column is-3">
                                    
                                    <div class="boards-grid setup-center" v-if="true">

                                        <a @click="redirect" class="card board">
                                        
                                            
          <div class="card-content info" type="is-info">
            <div class="content">
              <div class="media-content">
                <b-tag class="is-pulled-right" type="is-white" style="background-color: transparent;" v-if="newProject.model_metrics != undefined && 'accuracy' in newProject.model_metrics">
                  <b-tooltip label="Accuracy"
                      position="is-bottom"
                      type="is-light">
                      {{  (newProject.model_metrics["accuracy"]*100).toFixed(0) }}/100
                  </b-tooltip>
                </b-tag>
                
                
                <p class="name title is-5">
                  {{newProject.name}}
                </p>
                
                
                <p class="description is-6">
                  <span v-if="newProject.description != undefined">
                    {{ newProject.description }}
                  </span>
                  <span v-else>
                    &nbsp;
                  </span>
                </p>
              </div>
            </div>

            <div class="bottom-left">
                <b-tag size="small" type="is-info" v-if="newProject.datasetId">
                    <b-button style="text-decoration: none;" type="is-ghost" size="is-small" :loading="true"></b-button>
                </b-tag>
                <b-tag size="small" type="is-success" v-else>
                  <i class="fa fa-check"></i>&nbsp;
                </b-tag>
            </div>
            <div class="bottom-right">
                
                <b-tag type="is-secondary">
                  {{ newProject.type }}
                </b-tag>
            </div>
          </div>
                                        </a>

                        
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>
                <div class="footer">
                        
                        <b-field>
                            <b-button
                                expanded
                                type="is-primary"
                                size="is-medium"
                                icon-pack="fas"
                                icon-right="angle-right"
                                @click="redirect">
                                Go to project
                            </b-button>
                        </b-field>
                </div>

                    
            </div>
        </div>
            
    <b-modal
          v-model="isModalUploadOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Model"
          aria-modal
          scroll="keep">
          <template #default="props">
            <div class="modal-card box" style="min-width: 60em; min-height: 10em; width: auto">
                <div class="modal-card-body">
                    <!-- <h3 class="title is-3">
                        Add texts
                    </h3> -->
                    <Uploads @datasetId="getDatasetId" @isComplete="getImportStatus" @labels="getLabels" :isOnboarding="false" :project="newProject" :currentUser="currentUser" :rows="rows"/>
                </div>
            </div>
          </template>
      </b-modal>

      <b-modal
          v-model="isModalLabelsOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Model"
          aria-modal
          scroll="keep">
          <template #default="props">
            <div class="modal-card box" style="min-width: 60em; width: auto">
                <div class="modal-card-body">
                    <!-- <h3 class="title is-3">
                        Add labels
                    </h3> -->
                    <Labels :project="newProject" :records="rows" :currentUser="currentUser"/>
                </div>
            </div>
          </template>
      </b-modal>


      <b-modal
          v-model="isModalRecordsOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Model"
          aria-modal
          scroll="keep">
          <template #default="props">
            <div class="modal-card box" style="min-width: 60em; width: auto">
                <div class="modal-card-body">
                    <!-- <h3 class="title is-3">
                        Add labels
                    </h3> -->
                    <div class="content pb-50" v-for="row in rows">
                        <Records :row="row" :train="true" :project="newProject" :currentUser="currentUser"></Records>
                    </div>
                </div>
            </div>
          </template>
      </b-modal>

        </section>
    </form>

    
    </template>
    <script>
    

import Uploads from "@/dashboard/Project/Uploads.vue";
import RecordsClassify from "@/dashboard/Project/Records.vue";
import RecordsExtract from "@/dashboard/Project/RecordsNER.vue";
import Try from "@/components/ProjectCreateTry.vue";
import Labels from "@/dashboard/Project/Labels.vue";
import hljs from 'highlight.js';
import CodeEditor from "simple-code-editor";
import mixin from '@/utils/sharedFunctions.js'

export default {
    mixins: [mixin],

      props: {
        stepId: String
      },
      data() {
        return {
            importDataCompleted: false,
            isModalUploadOpen: false,
            isModalLabelsOpen: false,
            isModalRecordsOpen: false,
            projectId: null,
            labels: [],
            modelSize: 'medium',
            modelType: 'classification',
            modelLabels: [],
            modelTrials: 0,
            projectName: null,
            language: 'Multilingual',
            created: false,
            setupStep: 0,
            learningStrategy: "llm-prompt",
            learningStrategyMapping: {
                "llm-prompt": "few-shot", 
                "fine-tune": "fine-tune",
            },
            code: 'console.log("Hello World")',
            datasetId: null,
            showSteps: false,
            try_records: [],
            text: "John Doe works at ABC Corporation in New York. The event will be held at 9:00 AM on May 20, 2023.",
            adding_label: undefined,
            multiLabel: false,
            instruction: '',
            text_sample: '',
            output_sample: '',
            inference_result: false,
            add_as_records: false,
            readyToCreate: false,
            isLoading: false,
            settings: {
                readOnly: true,
                rowHeaders: true,
                licenseKey: 'non-commercial-and-evaluation'
            },
            inputTaskList: [{id: 'manual', name: 'Generate texts'}, {id: 'csv', name: 'From CSV'}, {id: 'pdf', name: 'From any DOC'},{id: 'library', name: 'From Our Library'}],
            inputTask: false,
            availableInputTask: ['csv', 'pdf', 'html', 'library', 'api', 'manual'],
            
            modelTypeList: [
                {id: 'classification', name: 'Text Classification', tags: ['Classify to one or many categories', 'Topic & sentiment analysis', 'Intent recognition']},
                // {id: 'tagging', name: 'Tagging', step: 'train'},
                // {id: 'sentiment', name: 'Sentiment', step: 'train'},
                {id: 'extraction', name: 'Text Extraction', tags: ['Tag and extract information', 'Entity recognition', 'Keywork extraction']},
                // {id: 'tabular-classification', name: 'Tabular', step: 'train'},
                // {id: 'hire', name: 'Services', tags: ['Consulting for AI and data ', 'Build private LLM']},
                // {id: 'answering', name: 'Sentiment', step: 'train'},
                {id: 'generation', name: 'Text Generation', tags: ['Fine-tune LLM with your data', 'Question and Answering & RAG', 'Summarization']},
                
            ],
            availableTasks: ['classification', 'extraction'],
            datasetsLibrary: [
                {id: 'ag_news', name: 'Topic classification', description: "News articles from 4 categories: World, Sports, Business, Sci/Tech"},
                // {id: 'banking77', name: 'Intent recognition', description: "Banking support tickets from 12 categories"},
                // {id: 'sst2', name: 'Sentiment analysis', description: "Movie reviews from 2 categories: positive, negative"},
            ],
            sampleDataframe: false,
            datasetName: '',
            isFinished: false,
            selectedDataset: 'ag_news',
            csv: null,
            label_col: false,
            text_col: false,
            animated: true,
            imageData: null,
            file2: false,
            picture: null,
            files: [],
            uploadValue: 0,
            done: false,
            csv: 1,
            json: 1,
            previewDataset: null,
            isComponentModalActive: false,
            isComponentDatasetEditActive: false,
            selectedTask: null,
            textarea: null,
            modelSizeNames: {
                small: 'RoBERTa',
                medium: 'Phi 2',
                large: 'LLama 2 13B'
            },
            modelSizePrice: {
                small: 1,
                medium: 2,
                large: 4,
            },
        };
      },
      components: {
        Uploads,
        RecordsClassify,
        RecordsExtract,
        Try,
        Labels,
        CodeEditor
      },
      
      filters: {
            pretty: function(value) {
                console.log(value)
                return JSON.stringify(value, null, 2);
            }
      },
      computed: {
        newProject() {
            return this.$store.state.newProject;
        },
        currentUser() {
          return this.$store.state.currentUser;
        },
        currentOrg() {
          return this.$store.state.currentOrg;
        },
        plans() {
            return this.$store.state.plans
        },
        datasets() {
            return this.$store.state.datasets //publicDatasets
        },
        rows() {
            if (this.newProject.datasetId){
                return this.$store.getters.rowsByDataset(this.newProject.datasetId)
            } else {
                return []
            }
        },
      },
      directives: {
    highlight: {
      insert(el, binding) {
        el.textContent = binding.value;
        hljs.highlightElement(el);
      },
      update(el, binding) {
        if (el.scrolling) {
          el.scrolling = false;
        } else {
          delete el.dataset.highlighted;
          el.textContent = binding.value;
          hljs.highlightElement(el);
        }
      },
    },
  },
  created() {
        
      },
      mounted(){
        let stepId = this.$route.params.stepId
        this.$store.dispatch("currentUser")
      },
      watch: {
        project(){
            this.getLabels()
            this.getRows()
        }
      },
      methods:{
        taskSelection(id){
            if (id == 'generation'){
                window.open('https://tally.so/r/3EdBKl', '_blank')
            } else {
                this.modelType = id; 
                this.setupStep += 1    
            }
            
        },
        updatePromptModel(params){
            this.labels = params.labels
            this.modelSize = params.modelSize
            this.multiLabel = params.multiLabel
            this.instruction = params.instruction
            
            this.getRows()
        },
        // userPlan(){
        //     let hasPlanName = Object.hasOwn(this.currentUser, 'plan') ? Object.hasOwn(this.currentUser.payment, 'plan') : false
        //     let plan = hasPlanName ? this.currentUser.payment.plan.toLowerCase() : false
        //     return plan ? plan : "starter"
        // },
        // getRecordsLimit(){
        //     let hasDatasetRowsLimit = Object.hasOwn(this.currentUser, 'plan') ? Object.hasOwn(this.currentUser.plan, 'datasetRowsLimit') : false
        //     let recordsLimit = hasDatasetRowsLimit ? this.currentUser.plan.datasetRowsLimit : 1000
        //     return recordsLimit
        // },
        // getRecordsAdded(){
        //     return this.rows.length > 10 ? this.rows.length : 10
        // },
        // creditsNeeded(){
        //     let dot = this.modelSizePrice[this.modelSize]
        //     let rowsLength = this.getRecordsAdded()
        //     if ( this.modelTrials > 1){
        //         return parseInt(rowsLength * (1 + this.modelTrials / 5) * dot)
        //     } else {
        //         return parseInt(rowsLength * dot)
        //     }
        // },
        // enoughCredits(){
        //     let credits = this.currentUser.creditsRemaining
        //     let records = this.creditsNeeded()
        //     return credits >= records
        // },
        // availableCredits(){
        //     let credits = this.currentUser.creditsRemaining
        //     return credits || 0
        // },
        getImportStatus(isCompleted){
            this.importDataCompleted = isCompleted
            this.getRows()
        },
        getDatasetId(datasetId){
            this.datasetId = datasetId
        },
        title(){
            try {
                return this.engines[this.radioButton].title
            } catch {
                return false
            }
            
        },
        setTextarea(textarea) {
  this.textarea = textarea;
},
getQuery() {
  return this.textarea.value;
},
        description(){
            try {
                return this.engines[this.radioButton].description
            } catch {
                return false
            }
        },
        stepCheck(){
            if (this.setupStep == 1){
                this.createProjectDraft()
            } else if (this.newProject.id != null){
                this.$store.dispatch("newProject", this.newProject.id);
            }
        },
        setupCurrentStep(){
            let step = this.setupStep
            // classification, 0, 1, 2, 3, 4
            // classification, 0, 1, 2, 3, 4

        },
        getRows(){
            this.isLoading = true
            this.$store.dispatch('getRowsByDataset', this.newProject.datasetId)
            setTimeout(() => {
                this.isLoading = false
            },  300)
        },
        getLabels(newLabels = null){
            const isFinetuning = this.learningStrategy == "fine-tune"
            if (isFinetuning){
                this.labels = this.newProject.labels.map(label => label.label)
            }
        },
        createProjectDraft(){

            this.$store.dispatch("updateProject",
                {projectId: this.newProjectId, update: {type: this.modelType}}
            )

            let hasProjectDraft = Object.hasOwn(this.newProject, 'id') ? this.newProject.id != undefined : false

            if (hasProjectDraft && this.newProject.type == null){ // has project id then only update labels
                this.$store.dispatch("newProject", this.newProject.id).then( () => {
                    this.getRows()
                })
                return;
            }
            
            const project = {
                name: "Untitled",
                type: this.modelType,
                draft: true,
                labels: [],
                tags: [],
            }

            var newDoc = this.$store.dispatch("createProject",
                project
            )

            let _projectId = null

            newDoc.then(projectId => {
                
                // create dataset
                const dataset = {
                    "projectId": projectId,
                    "splitOption": null
                }

                var newDataset = this.$store.dispatch("createDataset",
                    dataset
                )

                newDataset.then(datasetId => {
                    const addDatasetToProject = {
                        "projectId": projectId,
                        "update": {"datasetId": datasetId}
                    }
                    console.log(addDatasetToProject)
                    this.$store.dispatch("addDatasetToProject", addDatasetToProject)

                })

                this.$store.dispatch("newProject", projectId).then( () => {
                    this.getRows()
                })
            })
        },
        prepareLabels(){
            let modelLabels = []
            if (this.labels.length < 1) return modelLabels

            this.labels.forEach(function (label, i) {
                modelLabels.push({label_code: i, label: label})
            });
            
            return modelLabels
        },
        createProject(){
            // Ask for at least one label
            if(this.labels.length < 1){
                this.$buefy.dialog.alert({
                    message: '<b>Attention:</b> Please ensure you provide at least one label for your project.<br><br> <b>Example:</b><br> For spam detection, you can define labels such as "spam" and "not spam." The model will learn to categorize text into these specified labels.<br><br> If you already have a dataset annotated with labels, start by adding the first label. In the next step, you can effortlessly upload your CSV file, and all the labels will be automatically loaded.'
                });
                return; // stop
            }

            // Set loading spinning
            this.isLoading = true
            
            // Prepare labels (from list to dict)
            let labels = this.prepareLabels()
            
            if (labels.length == 1){
                labels.push({label_code: labels[0].label_code, label: `not ${labels[0].label}`})
            }

            // Create a model
            const model = {
                name: this.uniqueReadableName(),
                projectId: this.newProject.id,
                datasetId: this.newProject.datasetId,
                type: this.modelType,
                strategy: this.learningStrategy,
                size: this.modelSize,
                labels: labels,
                language: this.language,
                multilabel: this.multiLabel,
                instruction: this.instruction,
                encoder: 'bert-base-uncased',
                userId: this.currentUser.id
            }

            console.log(model)

            var newDoc = this.$store.dispatch("createModel",
                model
            );

            newDoc.then(newModelId => {
                
                const addModelToProject = {
                  projectId: this.newProject.id,
                  add: {
                    models: [newModelId],
                    modelId: newModelId,
                  }
                }
                console.log(addModelToProject)
                this.$store.dispatch("addModelToProject",
                  addModelToProject
                );
            })

            // Create a project
            const projectToUpdate = {
                projectId: this.newProject.id,
                update: {
                    name: (this.projectName)?this.projectName:"Untitled",
                    type: this.modelType,
                    labels: labels,
                    language: this.language,
                    size: this.modelSize,
                    strategy: this.learningStrategy,
                    draft: false
                }
            }

            console.log(projectToUpdate)

            var newProjectDoc = this.$store.dispatch("updateProject",
                projectToUpdate
            )

            // Go though the final step onboarding
            newProjectDoc.then(() => {
                this.projectCreated = true
                this.setupStep = 5
            })

            const toUpdateCreditsConsumed = {
                userId: this.$firebase.auth().currentUser.uid,
                creditConsumed: this.creditsNeeded()
            }

            this.$store.dispatch("updateAPICreditsConsumed", 
                toUpdateCreditsConsumed
            );

            this.isLoading = true
            
            setTimeout(() => {
                this.isLoading = false
            },  1000)

            this.done = true
            
        },
        joinEarlyAccess() {
                this.$buefy.dialog.confirm({
                    title: 'Join Early Access',
                    message: `<b>Extraction and generation tasks that are currently in development</b>. <br>Be among the first to experience the power of these features by joining our Early Access program. By joining, you'll have the <b>opportunity to test it for free before they're publicly launched</b>. Your feedback will be invaluable in shaping these features for the best user experience. <br><br>Click the button below to request Early Access.`,
                    cancelText: 'Cancel',
                    confirmText: 'Join Early Access',
                    type: 'is-primary',
                    onConfirm: () => window.open('https://tally.so/r/3EdBKl', '_blank')
                })
        },
        completeConfirm(){
            this.isLoading = false
            this.setupStep = 5
        },
        openLoading() {
                let isFullPage = true
                const loadingComponent = this.$buefy.loading.open({
                    container: isFullPage ? null : this.$refs.element.$el
                })
                setTimeout(() => loadingComponent.close(),  3*1000)
        },
        redirect(){
            let project_name = (this.projectName)?this.projectName:"Untitled"
            this.$buefy.toast.open(`Opening the project ${project_name}...`)
            
            let step = 'train'

            this.isLoading = true
            setTimeout(() => {
                this.$router.push(`/projects/${this.newProject.id}/${step}/tutorial`)
            },  10)
            
        },
        highlight_extract(result) {
            if (!result) return;

            if(this.modelType != 'extraction') {
                return result;
            }

            let highlight = []
            let highlight_text = this.text
            result.forEach(async (r) => {
                highlight_text = highlight_text.replace(new RegExp(r.text, "gi"), match => {
                    return `<span style="margin-bottom: 5px" data-entity="${r.label.toLowerCase()}">${match} <span class='entities-type'><b>${r.label}</b></span></span>`;
                });
                
                highlight.push(highlight_text)
            });
            
            return highlight.slice(-1)
        },
        runInference(){
            this.inference(this.modelType, this.text, this.labels)
        },
        inference(model_type, text, labels){
            let isFullPage = false
            this.isInference = true
            const loadingComponent = this.$buefy.loading.open({
                container: isFullPage ? null : this.$refs.inference_result.$el
            })
            this.$store.dispatch(
                "getPreBuildModelInference",
                {text: text, labels: labels, modelId: model_type}
            ).then( (res) => {
                this.isInference = false
                this.inference_result = {prediction: res.prediction, confidence: res.confidence}
                loadingComponent.close()
                this.addAsRecords(text, res.prediction)
            })
        },
        highlighter(code) {
            return highlight(code, languages.js); // languages.<insert language> to return html with markup
        },
        createRecords(record){
            this.$store.dispatch(
                "addRecord",
                    {   text: record.text, 
                        labels: record.labels || [], 
                        tags: record.tags || [],
                        projectId: this.newProject.id,
                        datasetId: this.newProject.datasetId
                    }
            ).then( record_data => {
                this.getRows()
            })
        },
        addAsRecords(text, label){
            this.try_records.push({
                id: null,
                text: text,
                labels: label,
                createdAt: new Date().getTime()
            })
        }
      }
        
    }
    </script>
    <style lang="scss" scoped>

.item{
    display:flex;
    flex-direction:column;
    justify-content:space-between
  }

.columns button{
    margin-top: auto;
  }


.footer {
    position: fixed;
    height: 50px;
    bottom: -30px;
    left: 0px;
    right: 0px;
    margin-bottom: 0px;
}
.selected-setup {
    cursor: pointer;
    border: dashed 2px #3482F6;
    border-radius: 0px;
    min-height: 10em;
  
    &:hover {
      border: dashed 2px #1367e5;
    }
  }
  
.setup-grid-input {
    display: grid;
    justify-content: center;
    align-content: center;
    grid-auto-flow: column;
    grid-template-columns: repeat(auto-fill, minmax(100px, 2fr));
    gap: 1em;
  
    .setup-selected {
          border: dashed 3px #bdbdbd !important;
      }
  
    .setup {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
    grid-auto-flow: column;
    
    align-items: center;
    justify-items: center;
  
      &:hover {
        background: #fafafa;
        border: dashed 1px #bdbdbd;
      }
  
      &:active {
          border: dashed 2px #bdbdbd;
      }
  
      &:checked {
          border: dashed 2px #bdbdbd;
      }
      
  
      .info {
        padding: 16px;
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }
      }
    }
  }

.setup-grid {
    display: grid;
    justify-content: center;
    align-content: center;
    grid-auto-flow: column;
    grid-template-columns: repeat(auto-fill, minmax(140px, 2fr));
    gap: 3em;
  
    .setup-selected {
          border: dashed 2px #bdbdbd !important;
      }
  
    .setup {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
    grid-auto-flow: column;
    
    align-items: center;
    justify-items: center;
  
      &:hover {
        background: #fafafa;
        border: dashed 2px #bdbdbd;
      }
  
      &:active {
          border: dashed 2px #bdbdbd;
      }
  
      &:checked {
          border: dashed 2px #bdbdbd;
      }
      
  
      .info {
        padding: 16px;
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }
      }
    }
  }
  
  .setup-center {
    margin: 0 auto;
  }


  .boards-grid-small {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 16px;
}

.boards-list {
    display: grid;
    gap: 16px;

  
    .board-create {
      cursor: pointer;
      border: dashed 4px #e6e4e4;
      border-radius: 0px;
      min-height: 10em;
    
      &:hover {
        border: dashed 4px #bdbdbd;
      }
    }
    .board {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
      min-height: 2em;
  
      &:hover {
        background: #fafafa;
      }
  
      .info {
        padding: 10px;
        display:flex;
        flex-direction:column;
        justify-content:space-between
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }

        .bottom-left {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          left: 0.8em;
        }
        .bottom-right {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          right: 0.8em;
        }
      }
    }
}

.boards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;

  
    .board-create {
      cursor: pointer;
      border: dashed 4px #e6e4e4;
      border-radius: 0px;
      min-height: 10em;
    
      &:hover {
        border: dashed 4px #bdbdbd;
      }
    }
    .board {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
      min-height: 10em;
  
      &:hover {
        background: #fafafa;
      }
  
      .info {
        padding: 16px;
        display:flex;
        flex-direction:column;
        justify-content:space-between
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }

        .bottom-left {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          left: 0.8em;
        }
        .bottom-right {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          right: 0.8em;
        }
      }
    }
}

</style>